import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';

const VendorDetailsCard = ({
  vendorRef, vendorSearch, setVendorSearch, setSelectedVendor,
  vendorDropdownOpen, setVendorDropdownOpen, filteredVendors, selectVendor,
  warehouses, selectedWarehouse, setSelectedWarehouse,
  entryDate, setEntryDate, invoiceNumber, setInvoiceNumber,
  challanNumber, setChallanNumber, peNotes, setPeNotes,
}) => (
  <Card>
    <CardContent className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="relative" ref={vendorRef}>
          <Label className="text-xs font-semibold text-gray-600">Vendor *</Label>
          <Input value={vendorSearch}
            onChange={e => { setVendorSearch(e.target.value); setVendorDropdownOpen(!!e.target.value.trim()); if (!e.target.value) setSelectedVendor(''); }}
            placeholder="Search vendor..." className="h-9 text-sm" data-testid="pe-vendor-search"
          />
          {vendorDropdownOpen && filteredVendors.length > 0 && (
            <div className="absolute z-50 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
              {filteredVendors.map(v => (
                <div key={v.id} className="px-3 py-2 hover:bg-emerald-50 cursor-pointer text-sm"
                  onClick={() => selectVendor(v)} data-testid={`pe-vendor-option-${v.id}`}>
                  <span className="font-medium">{v.name}</span>
                  {v.city && <span className="text-gray-400 ml-2">({v.city})</span>}
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <Label className="text-xs font-semibold text-gray-600">Warehouse *</Label>
          <select value={selectedWarehouse} onChange={e => setSelectedWarehouse(e.target.value)}
            className="flex h-9 w-full rounded-md border border-input bg-background px-2 py-1 text-sm" data-testid="pe-warehouse">
            <option value="">Select</option>
            {warehouses.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
          </select>
        </div>
        <div>
          <Label className="text-xs font-semibold text-gray-600">Entry Date</Label>
          <Input type="date" value={entryDate} onChange={e => setEntryDate(e.target.value)} className="h-9 text-sm" data-testid="pe-entry-date" />
        </div>
        <div>
          <Label className="text-xs font-semibold text-gray-600">Invoice Number</Label>
          <Input value={invoiceNumber} onChange={e => setInvoiceNumber(e.target.value)} placeholder="INV-001" className="h-9 text-sm" data-testid="pe-invoice" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-3">
        <div>
          <Label className="text-xs font-semibold text-gray-600">Challan Number</Label>
          <Input value={challanNumber} onChange={e => setChallanNumber(e.target.value)} placeholder="CH-001" className="h-9 text-sm" data-testid="pe-challan" />
        </div>
        <div className="col-span-2">
          <Label className="text-xs font-semibold text-gray-600">Notes</Label>
          <Input value={peNotes} onChange={e => setPeNotes(e.target.value)} placeholder="Entry notes..." className="h-9 text-sm" data-testid="pe-notes" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export default VendorDetailsCard;
